module.exports = __webpack_public_path__ + "static/media/powerBi.3b1a3ebb.png";